import { jsx } from "react/jsx-runtime";
import React from "react";
var clipboard_checkmark_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.661 4.4053c-.1353.2164-.161.5395-.161 1.0947V6h3.0007L13.5 5.5c0-.5574-.0248-.8794-.1597-1.0954C13.2764 4.302 13.0516 4 12 4c-1.0483 0-1.2741.3016-1.339.4053zM8.9654 3.3447C9.5261 2.4484 10.5502 2 12 2c1.4513 0 2.4765.4479 3.0369 1.3455.1322.2117.2268.434.2944.6545H20v8h-2V6h-2.4993l.0026 2H8.5V6H6v14h5v2H4V4h4.67c.0678-.2207.1628-.4432.2954-.6553zm12.0488 9.8173-6.0104 6.0104-3.1819-3.1819-1.4143 1.4142 4.5962 4.5962 7.4247-7.4247-1.4143-1.4142z" })];
};
export {
  clipboard_checkmark_default as default
};
